<div [ngClass]="class">
  <span>{{ message }}</span>
  <span matSnackBarActions *ngIf="showButton">
    <button
      mat-raised-button
      matSnackBarAction
      (click)="snackBarRef.dismissWithAction()"
    >
      OK
    </button>
  </span>
</div>
